import styled from '@emotion/styled';

export default styled('div')`
  font-size: 25px;
  padding: 5px 0;
`;
